import Layout from './Layout'
import GuidePage from './pages/GuidePage'
import SafetyPage from './pages/SafetyPage'
import ComparePage from './pages/ComparePage'
import GlossaryPage from './pages/GlossaryPage'
import FaqPage from './pages/FaqPage'
import StartPage from './pages/StartPage'

const pageMap: Record<string, React.ComponentType> = {
  '/guide/': GuidePage,
  '/safety/': SafetyPage,
  '/compare/': ComparePage,
  '/glossary/': GlossaryPage,
  '/faq/': FaqPage,
  '/start/': StartPage,
}

export default function SubpageApp() {
  const path = window.location.pathname.endsWith('/') ? window.location.pathname : window.location.pathname + '/'
  const PageComponent = pageMap[path]

  if (!PageComponent) {
    window.location.href = '/'
    return null
  }

  return (
    <Layout>
      <PageComponent />
    </Layout>
  )
}
